import {createAction, props} from "@ngrx/store";
export const addAgency = createAction('[Agency] Add Agency', props<{ agencies: string[] }>());
export const removeAgency = createAction('[Agency] Remove Agency', props<{ agency: string }>());
export const removeAllAgencies = createAction('[Agency] Remove All Agency');
